import React from 'react';
import { licenseWarnings } from '../lib/bookingChecks';

export default function DriverLicenseWarnings({ booking, referenceDate }) {
  const warnings = licenseWarnings(booking, referenceDate);
  return (
    <div className={`border rounded-sm p-3 text-sm ${warnings.length ? 'border-amber-300 bg-amber-50 text-amber-900' : 'border-green-200 bg-green-50 text-green-800'}`} data-testid="driver-license-check">
      <p className="font-semibold">Führerscheindaten · Haupt- und Zusatzfahrer</p>
      {warnings.length ? <ul className="mt-2 space-y-1">{warnings.map(w => <li key={w.index}>{w.name}: {w.problems.join('; ')}.</li>)}</ul> : <p>Führerscheindaten vollständig und bis Mietende gültig.</p>}
      <p className="text-xs mt-2">Bitte die Originaldokumente bei der Übergabe prüfen.</p>
    </div>
  );
}
